type CardProps = {
  header: JSX.Element;
  body: JSX.Element;
  footer?: JSX.Element;
  containerClassName?: string;
};

const Card = ({ header, body, footer, containerClassName }: CardProps) => {
  return (
    <div className={containerClassName}>
      {header}
      {body}
      {footer}
    </div>
  );
};

export default Card;
